import React, { Component } from 'react'
import Swatch from './Swatch'
import AutoCompleteSearches from '../../../util/auto_complete/Searches'

export default class ShortcodeOption extends Component {
  state = {
    enabled: false
  }

  toggleEnabled = () => {
    let { enabled } = this.state
    enabled = !enabled
    this.setState({ enabled })
    const { name, type, query, onChange, value } = this.props
    if (type === 'show' || type === 'hide') {
      const set = new Set(query[type])
      if (enabled) {
        set.add(name)
      } else {
        set.delete(name)
      }
      if (set.size) {
        onChange({ ...query, [type]:[...set] })
      } else {
        delete query[type]
        onChange({ ...query })
      }
    } else if (type === 'render') {
      const e = document.getElementById(`${name}-selector`)
      const val = e ? e.value : 'bestfit'     // assume bestfit if selector not visible yet

      if (!enabled)
        delete query[name]
      else
        query[name] = val

      onChange({...query})

    } else if (type === 'boolean') {
      if (enabled) {
        onChange({ ...query, [name]: value })
      } else {
        delete query[name]
        onChange({ ...query })
      }
    } else {
      delete query[name]
      onChange({ ...query })
    }
  }

  getValueChooser() {
    if (!this.state.enabled) return
    const { type, name, query, onChange } = this.props
    switch(type) {
      case 'number': return (
        <input
          type="number"
          autoFocus
          onChange={event => onChange({ ...query, [name]: event.target.value })} />
      )
      case 'text': return (
        <input
          type="text"
          autoFocus
          onChange={event => onChange({ ...query, [name]: event.target.value })} />
      )
      case 'color': return (
        <Swatch onChange={color => onChange({ ...query, [name]: color })} />
      )
      case 'search': return (
        <AutoCompleteSearches onSelect={search => search && onChange({ ...query, [name]: search.id })} />
      )
      case 'render': return (
        <select id={`${name}-selector`} onChange={event => onChange({ ...query, [name]: event.target.value})}>
          <option value="bestfit">Text or Icon (best fit)</option>
          <option value="text">Text Always</option>
          <option value="icon">Icon Always</option>
        </select>
      )
    }
  }

  render() {
    const { label } = this.props
    return (
      <div className="shortcode-option">
        <label>
          <input type="checkbox" checked={this.state.enabled} onChange={this.toggleEnabled} />
          {' '}
          {label}
        </label>
        {this.getValueChooser()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/website/Shortcodes/Option.js